import React, { useEffect, useReducer, useState } from 'react';
import {
  ApSecureContainer,
  ApSecureHeader,
  ApSecureHeaderTitle,
  ApSecureHeaderArea
} from './styles';
import Copyright from '../../components/Copyright';
import { useHistory, useLocation } from 'react-router-dom';
import { ApSecureContext } from '../../store';
import apSecureReducer from '../../store/ApSecure';
import INITIAL_STATE_AP_SECURE from '../../store/ApSecure/state';
import { apSecureSteps } from '../../helpers/enum';
import HomePage from './Home';
import ChoseOptionPage from './ChoseOption';
import BeneficiaryPage from './Beneficiary';
import TakerPage from './Taker';
import ChosePlanPage from './Plans';
import { P, H4 } from '../../components/Typography/styles';
import colors from '../../assets/styles/colors';
import { default as ApSecureTypes } from "../../store/ApSecure/types";
import { getCreditById } from '../../services/credit';
import { getSolicitationById } from '../../services/solicitations';
import Loader from '../../components/Loader';
import ModalAction from '../../components/ModalAction';
import { BsExclamation } from 'react-icons/bs';
import { omitApSecure } from '../../services/apSecure';
import AlertaValidacionIdentidad from '../../components/AlertaValidacionIdentidad';

const ApSecurePage = () => {
  const location = useLocation();
  const history = useHistory();
  const [apSecure, setApSecure] = useReducer(apSecureReducer, INITIAL_STATE_AP_SECURE);
  const [activeStep, setActiveStep] = useState(apSecureSteps.DEFAULT);
  const [isLoading, setIsLoading] = useState(true);
  const [superaEdad, setSuperaEdad] = useState(false);

  async function initializaStateComponent() {
    try {
      const creditResponse = await getCreditById(location.idCredit);
      const solicitationResponse = await getSolicitationById(location.idCredit);

      if(solicitationResponse.data.credito.idLineaCredito == 6 || solicitationResponse.data.credito.idLineaCredito == 7){
        giveApSecure();
      }

      solicitationResponse.data.cliente.edadCliente > 79 ? setSuperaEdad(true) : setSuperaEdad(false);

      await setApSecure({
        type: ApSecureTypes.SET_CREDIT,
        credit: creditResponse.data
      })

      await setApSecure({
        type: ApSecureTypes.SET_SOLICITATION,
        solicitation: solicitationResponse.data
      })

      await setApSecure({
        type: ApSecureTypes.SET_BENEFICIARIE_USER_INFO,
        beneficiariesUserInfo: {
          ...apSecure.beneficiariesUserInfo,
          nombre: solicitationResponse.data?.cliente.nombres
        }
      })

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  async function giveApSecure() {
    try {
      setIsLoading(true);
      const data = {
        idCredito: location.idCredit
      }

      await omitApSecure(data);

      setIsLoading(false);
      history.push({
        pathname: '/admin/references',
        idCredit: location.idCredit
      })
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (!location.idCredit) {
      return history.push('/admin/dashboard');
    }

    initializaStateComponent()
  }, [])

  return (
    <ApSecureContainer id="exception-page">
      {isLoading ? <Loader /> : (
        <>
          <ApSecureHeader>
            <ApSecureHeaderTitle>Clientes</ApSecureHeaderTitle>
            <ApSecureHeaderArea>
              <H4 color={colors.textPrimary}>Seguro AP (Accidentes personales)</H4>
              <P bold color={colors.textPrimary}>
                {apSecure.solicitation?.cliente.nombres} {apSecure.solicitation?.cliente.tipoIdentificacion.toUpperCase()}. {apSecure.solicitation?.cliente.identificacion}
              </P>
            </ApSecureHeaderArea>
            <div style={{display: 'flex', justifyContent: 'flex-end' }}>
      <AlertaValidacionIdentidad idCredito={location.idCredit}/>
      </div>
          </ApSecureHeader>
          <ApSecureContext.Provider value={{ apSecure, setApSecure }}>

            {activeStep === apSecureSteps.DEFAULT && !superaEdad && (
              <HomePage setActiveStep={setActiveStep} />
            )}

            {activeStep === apSecureSteps.CHOSE_OPTION && (
              <ChoseOptionPage setActiveStep={setActiveStep} />
            )}

            {activeStep === apSecureSteps.CHOSE_PLAN && (
              <ChosePlanPage setActiveStep={setActiveStep} />
            )}

            {activeStep === apSecureSteps.BENEFICIARY && (
              <BeneficiaryPage setActiveStep={setActiveStep} />
            )}

            {activeStep === apSecureSteps.TAKER && (
              <TakerPage setActiveStep={setActiveStep} />
            )}
          </ApSecureContext.Provider>
          <Copyright />
          <ModalAction
            open={superaEdad}
            actionFunctionDownButton={() => giveApSecure()}
            title="Edad cliente no autorizado"
            description="El cliente que estás registrando no cumple la política de adquisición de pólizas."
            actionLabelFunctionDownButton="Continuar"
            backgroundIcon={colors.bgDanger}
            bodyIcon={<BsExclamation size={32} color={colors.textPrimary} />} />
        </>
      )}
    </ApSecureContainer>
  )
}

export default ApSecurePage;
